import RedsysResult from '../Views/RedsysResult'

const RedsysRoute = [{
    path: '/redsys',
    name: 'redsys',
    component: RedsysResult,
}]

export default RedsysRoute
